import type { CalculatorField } from './profitability.ts';

export type FieldUnit = 'money' | 'count' | 'percent';

export type FieldGroup = {
  readonly id: 'product' | 'advertising' | 'delivery' | 'rates';
  readonly fields: readonly CalculatorField[];
};

export const FIELD_GROUPS: readonly FieldGroup[] = [
  { id: 'product', fields: ['cost', 'price'] },
  { id: 'advertising', fields: ['leadCost', 'leads'] },
  { id: 'delivery', fields: ['deliveryFee', 'returnFee', 'preparationFee'] },
  { id: 'rates', fields: ['confirmationRate', 'deliveryRate'] },
];

export const FIELD_UNITS: Readonly<Record<CalculatorField, FieldUnit>> = {
  cost: 'money',
  price: 'money',
  leadCost: 'money',
  leads: 'count',
  deliveryFee: 'money',
  returnFee: 'money',
  preparationFee: 'money',
  confirmationRate: 'percent',
  deliveryRate: 'percent',
};

export const FIELDS_WITH_HELP: readonly CalculatorField[] = ['price', 'preparationFee'];
